// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__LcKcO","content":"styles_content__1tQtL","checkbox":"styles_checkbox__vQzyr","checkboxLabel":"styles_checkboxLabel__35BnF"};